export default __webpack_public_path__ + "img/91984ad96b19c1c365524f82af244312.svg";